export const validateNISorCPF = (value: any) => {
    if (!value) return Promise.resolve();

    // Verifica se é CPF
    if (validateCPF(value)) {
        return Promise.resolve();
    }

    // Verifica se é NIS
    if (
        value === '00000000000' ||
        value === '11111111111' ||
        value === '22222222222' ||
        value === '33333333333' ||
        value === '44444444444' ||
        value === '55555555555' ||
        value === '66666666666' ||
        value === '77777777777' ||
        value === '88888888888' ||
        value === '99999999999'
    ) {
        return Promise.resolve();
    }

    // Verifica se o valor é um CPF válido
    if (!validateLength(value) || (!validateDigitoVerificadorCPF(value) && !validateDigitoVerificadorNIS(value))) {
        return Promise.reject('NIS inválido');
    }

    return Promise.resolve();
};

// Função para validar o CPF
function validateCPF(cpf: any) {
    cpf = cpf.replace(/[.-]/g, '');    
    // Verifica se todos os dígitos são iguais
    if (/^(\d)\1+$/.test(cpf)) {
        return false;
    }

    // Verifica se o CPF tem 11 dígitos
    if (!validateLength(cpf)) {
        return false;
    }

    // Verifica os dígitos verificadores
    const peso = [10, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;

    for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * peso[i];
    }

    let resto = soma % 11;
    let digitoVerificador1 = resto < 2 ? 0 : 11 - resto;

    if (parseInt(cpf.charAt(9)) !== digitoVerificador1) {
        return false;
    }

    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * peso[i];
    }

    resto = soma % 11;
    let digitoVerificador2 = resto < 2 ? 0 : 11 - resto;

    return parseInt(cpf.charAt(10)) === digitoVerificador2;
}

function validateLength(nis: any) {

    nis = nis.replace(/[.-]/g, ''); // Remove caracteres não numéricos  
    if (nis.length !== 11) {
        return false;
    }
    //'Cadastro único inválido o NIS deve ter 11 dígitos'
    return true;
}

function validateDigitoVerificadorNIS(nis: any) {
    nis = nis.replace(/[.-]/g, '');
    const nisArray = nis.split('').map(Number);
    const digitoVerificador = nisArray.pop();

    const peso = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;

    for (let i = 0; i < 10; i++) {
        soma += nisArray[i] * peso[i];
    }

    const resto = soma % 11;
    let digitoCalculado = 11 - resto;

    if (digitoCalculado === 10 || digitoCalculado === 11) {
        digitoCalculado = 0;
    }

    return digitoCalculado === digitoVerificador;
}

function validateDigitoVerificadorCPF(cpf: any) {
    cpf = cpf.replace(/[.-]/g, '');
    const cpfArray = cpf.split('').map(Number);
    const digitoVerificador1 = cpfArray[9];
    const digitoVerificador2 = cpfArray[10];

    // Verifica o primeiro dígito verificador
    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += cpfArray[i] * (10 - i);
    }
    let resto = soma % 11;
    let digitoCalculado1 = resto < 2 ? 0 : 11 - resto;

    if (digitoCalculado1 !== digitoVerificador1) {
        return false;
    }

    // Verifica o segundo dígito verificador
    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += cpfArray[i] * (11 - i);
    }
    resto = soma % 11;
    let digitoCalculado2 = resto < 2 ? 0 : 11 - resto;

    return digitoCalculado2 === digitoVerificador2;
}